<template>
  <button class="block px-4 py-2 text-sm font-bold text-yellow-500 w-full text-left" @click="logout">Sign out</button>
</template>

<script>
import { useAuth0 } from '../auth0/Authentication'

export default {
  setup() {
    const auth0 = useAuth0()

    const logout = () => {
      if (!auth0) {
        return
      }

      auth0.logout({
        returnTo: window.location.origin,
      })
    }

    return {
      logout,
    }
  },
}
</script>
